//////// 5_1 EFSchema
const fiveOneSchema = {
  title: "5_1 Use Stage of the Product",
  cat: "5_1",
  catName: "cat5",
  progressiveOrderSwitch: {
    by: { level: 2, key: "emissionSource5_123" },
  },
  fields: [
    {
      key: "title",
      type: "title",
      title: "Emission Factor",
    },
    //////// Data Source
    {
      key: "emissionFactorTypeId",
      level: 1,
      type: "select",
      label: "Data Source",
      optionsAPI: "emissionFactorDropdown",
      autoFillNum: 0,
    },
    //////// Emission Source
    {
      key: "emissionSource5_1",
      level: 2,
      type: "select",
      label: "Emission Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        value: "5_1",
      },
      showIf: {
        all: [
          { level: 1, key: "emissionFactorTypeId", ne: "2" },
          { level: 1, key: "emissionFactorTypeId", notEmpty: true },
        ],
      },
      combineKey: 1,
    },
    //////////////// Emission Source 選 Energy Consumption 且 路徑 1
    //////// Energy Type
    {
      key: "energyType5_1",
      level: 3,
      type: "select",
      label: "Energy Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 2,
        key: "emissionSource5_1",
      },
      showIf: {
        all: [
          { level: 2, key: "emissionSource5_1", notEmpty: true },
          { level: 2, key: "emissionSource5_1", eq: "Energy Consumption" },
        ],
      },
      combineKey: 2,
    },
    //////// Emission Factor Database Source (路徑 1)
    {
      key: "sourceEFName5_1",
      level: 5,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 3,
        key: "energyType5_1",
      },
      showIf: {
        all: [
          { level: 3, key: "energyType5_1", notEmpty: true },
          { level: 3, key: "energyType5_1", eq: "Fuel" },
        ],
      },
      combineKey: 3,
    },
    //////// Fuel Type (路徑 1)
    {
      key: "fuelType5_1",
      level: 6,
      type: "select",
      label: "Fuel Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 5,
        key: "sourceEFName5_1",
      },
      showIf: {
        all: [
          { level: 3, key: "energyType5_1", notEmpty: true },
          { level: 3, key: "energyType5_1", eq: "Fuel" },
          { level: 5, key: "sourceEFName5_1", notEmpty: true },
        ],
      },
      combineKey: 4,
    },
    //////// Fuel Name (路徑 1)
    {
      key: "emissionFactorId",
      level: 7,
      type: "select",
      label: "Fuel Name",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 6,
        key: "fuelType5_1",
      },
      showIf: {
        all: [
          { level: 3, key: "energyType5_1", notEmpty: true },
          { level: 3, key: "energyType5_1", eq: "Fuel" },
          { level: 6, key: "fuelType5_1", notEmpty: true },
        ],
      },
      combineKey: 5,
    },
    //////////////// Emission Source 選 Energy Consumption 且 路徑 2
    //////// Energy Supplier (路徑 2)
    {
      key: "energySupplier",
      level: 4,
      type: "input",
      label: "Energy Supplier",
      resetOnChange: false,
      showIf: {
        all: [
          { level: 3, key: "energyType5_1", notEmpty: true },
          { level: 3, key: "energyType5_1", eq: "Purchased Electricity" },
        ],
      },
    },
    //////// Emission Factor Database Source (路徑 2)
    {
      key: "sourceEFName5_1",
      level: 5,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 3,
        key: "energyType5_1",
      },
      showIf: {
        all: [
          { level: 3, key: "energyType5_1", notEmpty: true },
          { level: 3, key: "energyType5_1", eq: "Purchased Electricity" },
        ],
      },
      combineKey: 3,
    },
    //////// Location ( Country ) (路徑 2)
    {
      key: "location5_1",
      level: 6,
      type: "select",
      label: "Location ( Country )",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 5,
        key: "sourceEFName5_1",
      },
      showIf: {
        all: [
          { level: 3, key: "energyType5_1", notEmpty: true },
          { level: 3, key: "energyType5_1", eq: "Purchased Electricity" },
          { level: 5, key: "sourceEFName5_1", notEmpty: true },
        ],
      },
      combineKey: 4,
    },
    //////// State / City (路徑 2)
    {
      key: "emissionFactorId",
      level: 7,
      type: "select",
      label: "State / City",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 6,
        key: "location5_1",
      },
      showIf: {
        all: [
          { level: 3, key: "energyType5_1", notEmpty: true },
          { level: 3, key: "energyType5_1", eq: "Purchased Electricity" },
          { level: 6, key: "location5_1", notEmpty: true },
        ],
      },
      combineKey: 5,
    },
    //////////////// Emission Source 選 Energy Consumption 且 路徑 3
    //////// Custom Emission Factor 路徑 3
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 7,
      type: "select",
      custom: true,
      label: "Custom Emission Factor",
      optionsAPI: "cat5CustomEFDropdownList",
      optionsParamFrom: {
        level: 3,
        key: "energyType5_1",
      },
      showIf: {
        all: [
          { level: 3, key: "energyType5_1", notEmpty: true },
          { level: 3, key: "energyType5_1", eq: "Renewable Energy" },
        ],
      },
    },
    //////////////// Emission Source 選 Energy Consumption 且 路徑 4
    //////// Custom Energy Name 路徑 4
    {
      key: "customEnergyName",
      level: 4,
      type: "input",
      label: "Custom Energy Name",
      resetOnChange: false,
      showIf: {
        all: [
          { level: 3, key: "energyType5_1", notEmpty: true },
          {
            level: 3,
            key: "energyType5_1",
            eq: "Others",
          },
        ],
      },
    },
    //////// Custom Emission Factor 路徑 4
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 7,
      type: "select",
      custom: true,
      label: "Custom Emission Factor",
      optionsAPI: "cat5CustomEFDropdownList",
      optionsParamFrom: {
        level: 3,
        key: "energyType5_1",
      },
      showIf: {
        all: [
          { level: 3, key: "energyType5_1", notEmpty: true },
          { level: 3, key: "energyType5_1", eq: "Others" },
        ],
      },
    },
    //////////////// Emission Source 選 Waste Treatment
    //////// Waste Management Vendor Name
    {
      key: "wasteManagementVendorName",
      level: 3,
      type: "input",
      label: "Waste Management Vendor Name",
      resetOnChange: false,
      showIf: {
        all: [
          { level: 2, key: "emissionSource5_1", notEmpty: true },
          {
            level: 2,
            key: "emissionSource5_1",
            eq: "Waste Treatment",
          },
        ],
      },
    },
    //////// Method of Calculation
    {
      key: "calculationId",
      level: 4,
      type: "select",
      label: "Method of Calculation",
      optionsAPI: "cat5Calculation",
      optionsParamFrom: {
        level: 2,
        key: "emissionSource5_1",
      },
      optionsLevel: false,
      showIf: {
        all: [
          { level: 2, key: "emissionSource5_1", notEmpty: true },
          { level: 2, key: "emissionSource5_1", eq: "Waste Treatment" },
        ],
      },
    },
    //////// Emission Factor Database Source
    {
      key: "sourceEFName5_1",
      level: 5,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 4,
        key: "calculationId",
      },
      showIf: {
        all: [
          { level: 2, key: "emissionSource5_1", notEmpty: true },
          { level: 2, key: "emissionSource5_1", eq: "Waste Treatment" },
          { level: 4, key: "calculationId", notEmpty: true },
        ],
      },
      combineKey: 2,
    },
    //////// Waste Treatment Method
    {
      key: "wasteTreatmentMethod5_1",
      level: 6,
      type: "select",
      label: "Waste Treatment Method",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 5,
        key: "sourceEFName5_1",
      },
      showIf: {
        all: [
          { level: 2, key: "emissionSource5_1", notEmpty: true },
          { level: 2, key: "emissionSource5_1", eq: "Waste Treatment" },
          { level: 5, key: "sourceEFName5_1", notEmpty: true },
        ],
      },
      combineKey: 3,
    },
    //////// Waste Type / Name
    {
      key: "emissionFactorId",
      level: 7,
      type: "select",
      label: "Waste Type / Name",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 6,
        key: "wasteTreatmentMethod5_1",
      },
      showIf: {
        all: [
          { level: 2, key: "emissionSource5_1", notEmpty: true },
          { level: 2, key: "emissionSource5_1", eq: "Waste Treatment" },
          { level: 6, key: "wasteTreatmentMethod5_1", notEmpty: true },
        ],
      },
      combineKey: 4,
    },
    //////// 自定義 (非階層)
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 7,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat5CustomEFDropdownList",
      showIf: {
        level: 1,
        key: "emissionFactorTypeId",
        eq: "2",
      },
      autoFillNum: 0,
    },
  ],
};
export default fiveOneSchema;
